module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.68ed1dac06bf0409c18a.woff";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.woff
// module chunks = 2